import React from "react";
import axiosApiInstance from "../../../helpers/axiosConfig";

const Position = (dispatch) => {
  axiosApiInstance
    .get(process.env.REACT_APP_API_DOMAIN + "api/v1/position")
    .then(res => {
      dispatch({type: "POSITION", position: res.data});
      dispatch({type: "POSITION_UPDATED", update_position: true});
    })
    .catch((error) => {
      console.error(error.message);
    });
};

export default Position;